import { ErrorMessage, Field } from 'formik';

const InputMobile = ({
  id,
  title,
  name,
  placeholder = '05XXXXXXXX',
  mandatory,
  parentClassName,
  labelClassName = '',
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-1 ${parentClassName}`}>
      <label className={`max-md:text-sm ${labelClassName}`} htmlFor={id}>
        {title} {mandatory && <span className='text-red-600'>*</span>}
      </label>
      <div dir='ltr' className='flex items-center'>
        <span className='mt-1 w-14 rounded-s-lg border border-[#E4E4F9] px-1 py-1.5 text-center max-md:text-[15px] max-sm:text-sm'>
          +966
        </span>
        <Field
          name={name}
          id={id}
          className='mt-1 flex-1 rounded-e-lg border border-s-0 border-[#E4E4F9] px-2 py-1.5 outline-none max-md:text-[15px] max-md:placeholder:text-[15px] max-sm:text-sm max-sm:placeholder:text-sm lg:px-4'
          placeholder={placeholder}
          {...props}
          maxLength={10}
        />
      </div>
      <ErrorMessage
        name={name}
        component='p'
        className='text-xs text-red-600 lg:text-sm'
      />
    </div>
  );
};

export default InputMobile;
